export function hasUserData(userData: string | null | undefined): boolean {
    return typeof userData === 'string' && userData.length > 0;
}

// Rebuild-confirmation line stating the stored user data survives the rebuild; shown only when some is set.
export const userDataRebuildNotice = 'Cloud-init user data will be applied to the rebuilt server.';

// Shared blurb describing cloud-init user data, shown on the read-only settings tab and the editable
// Reinstall / Change Plan option.
export const userDataDescription =
    'Cloud-init user data can work with cloud-init on the operating system to provide automated setup of new software, configuration of preferred defaults, and general customization of the Cloud Server after install.';
